import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import mediaFullSchema from '@utils/validate/blocksSchemes/mediaFullSchema';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const designersBlockSchema = Joi.object({
  type: Joi.string().valid('designersBlock').required(),
  code: Joi.string().allow('', null).required(),
  variant: Joi.string().valid('single', 'team').required(),
  voxboxButton: Joi.boolean().allow(null),
  name: Joi.string().allow('', null),
  title: Joi.string().allow('', null),
  description: Joi.string().allow('', null),
  buttonText: Joi.string().allow('', null),
  email: Joi.string().allow('', null),
  phone: Joi.string().allow('', null),
  video: mediaFullSchema(true),
  image: mediaUrlSchema,
  designers: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    email: Joi.string().allow('', null),
    phone: Joi.string().allow('', null),
    designerName: Joi.string().allow('', null).required(),
    description: Joi.string().allow('', null).required(),
    image: Joi.alternatives().try(Joi.string(), Joi.object(imageWithMetaDataSchema)).allow(null),
    thumbnail: Joi.alternatives().try(Joi.string(), Joi.object(imageWithMetaDataSchema)).allow(null)
  }).unknown(true))
}).unknown(true);
export default designersBlockSchema;